import { createSelector } from "reselect";
import _ from "lodash";
export const selectJobPack = ({ JobPackV2_reducer }) => {
    if (JobPackV2_reducer.mainReducer.jobPack) {
        return JobPackV2_reducer.mainReducer.jobPack.profile;
    } else return false;
};

export const selectNewJobPackID = ({ JobPackV2_reducer }) => {
    return JobPackV2_reducer.mainReducer.newJobPackID;
};
export const selectUsers = ({ JobPackV2_reducer }) => {
    return JobPackV2_reducer.mainReducer.users;
};
export const selectReportTypes = ({ JobPackV2_reducer }) => {
    return JobPackV2_reducer.mainReducer.reportTypes;
};
export const selectSSWPConfigs = ({ JobPackV2_reducer }) => {
    return JobPackV2_reducer.mainReducer.sswpConfigs;
};
export const selectSSWPConfigInfo = createSelector(
    [selectSSWPConfigs],
    (configs = false) => {
        if (configs) {
            let configInfo = Object.keys(configs).map(e => {
                let uid = e;
                let name = _.get(configs[e], "template_name") || "N/A";
                return { uid, name };
            });
            return configInfo;
        } else {
            return false;
        }
    }
);
export const selectUserInfo = createSelector(
    [selectUsers],
    (users = false) => {
        if (users) {
            let userInfo = _.compact(
                Object.keys(users).map(e => {
                    let uid = e;
                    let fname = _.get(users[e], "profile.first_name") || "N/A";
                    let lname = _.get(users[e], "profile.last_name") || "N/A";
                    let deleted = _.get(users[e], "profile.deleted") || false;
                    if (!deleted) {
                        return { uid, user_name: `${fname} ${lname}` };
                    } else return null;
                })
            );
            return userInfo;
        } else return false;
    }
);
